module.exports = __webpack_public_path__ + "media/shape/testimonial-01-cee003aa.png";